import { useStaticQuery, graphql } from 'gatsby'
import useMedia from 'react-use/lib/useMedia'
import dlv from 'dlv'

export const useIsDesktop = () => useMedia('(min-width: 48rem)')

export const useNavStructure = () => {
  const queryData = useStaticQuery(graphql`
    {
      referenceNav {
        structure
      }
    }
  `)

  return dlv(queryData, 'referenceNav.structure')
}
